import { Fragment } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';

import { Error } from '../Error';

import styles from './styles.module.scss';

const Segmented = ({
  disabled = false,
  errorMessage = null,
  handleClick,
  items,
  label,
  theme,
  value,
}) => (
  <Fragment>
    {label && <div className={styles.label}>{label}</div>}
    <div className={styles.buttonGroup}>
      {items.map((item) => (
        <div
          key={item.value}
          className={cc([
            styles.item,
            {
              [styles[theme]]: item.value === value,
              [styles.disabled]: item.value !== value && disabled,
            },
          ])}
          onClick={handleClick(item)}
        >
          <span
            className={cc([
              styles.buttonLabel,
              item.value === value ? styles.selectedText : null,
            ])}
          >
            {item.label}
          </span>
        </div>
      ))}
    </div>
    <Error value={errorMessage} />
  </Fragment>
);

Segmented.propTypes = {
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  handleClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  theme: PropTypes.string,
  value: PropTypes.any,
};

Segmented.displayName = 'Segmented';

export { Segmented };
